import { useLayoutEffect, useRef, useState } from "react";

// Renders children (an 816x1056 TaskSheet) scaled to fit the container width,
// preserving the 8.5x11 letter aspect ratio. Used for the poster-wall
// thumbnails and the modal preview.
export default function ScaledSheet({ children, maxScale = 1 }) {
  const ref = useRef(null);
  const [scale, setScale] = useState(0);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const update = () => setScale(Math.min(el.clientWidth / 816, maxScale));
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, [maxScale]);

  return (
    <div ref={ref} style={{ width: "100%", aspectRatio: "816 / 1056", overflow: "hidden", position: "relative", background: "#fff", borderRadius: 8 }}>
      <div style={{ position: "absolute", top: 0, left: 0, width: 816, height: 1056, transform: `scale(${scale})`, transformOrigin: "top left" }}>
        {children}
      </div>
    </div>
  );
}
